import type { Quest } from "../types";

// A weekday-only quest rests on Saturday and Sunday. The weekend is Manila's
// (fixed +8, no DST), the same clock as the engine's phDay.
const PH_OFFSET_MS = 8 * 3600 * 1000;
export const restsToday = (q: Pick<Quest, "days">, at: number = Date.now()): boolean => {
  if (q.days !== "weekdays") return false;
  const dow = new Date(at + PH_OFFSET_MS).getUTCDay();
  return dow === 0 || dow === 6;
};

// Client mirror of the API's reward gate. If any active daily is explicitly
// required, every such daily must be done today; otherwise one daily is enough.
export const dailyRewardEligible = (
  quests: Quest[],
  done: Record<string, boolean>,
  day: string,
  at: number = Date.now(),
): boolean => {
  const dailies = quests.filter((q) => (q.type || "").toLowerCase() === "daily");
  const required = dailies.filter((q) => (q.tier || "").toLowerCase() === "required" && !restsToday(q, at));
  const doneOnDay = (q: Quest): boolean => !!done[q.id] && (q.completed || "").slice(0, 10) === day;
  return required.length > 0 ? required.every(doneOnDay) : dailies.some(doneOnDay);
};
